import { FulfillmentTypeListResponseType } from "@sellar-io/api-v2/types";
import { DeliveryOptionsCardCompact } from "./DeliveryOptionsCardCompact";
import { useRemoteFeatureFlags } from "../../hooks/useRemoteFeatureFlags";

export const HaulierDeliveryOptionsCard = ({
  supplierId,
  haulierFulfillmentType,
}: {
  supplierId: number;
  haulierFulfillmentType:
    | Omit<
        FulfillmentTypeListResponseType[number],
        | "id"
        | "name"
        | "OrderRules"
        | "numberOfCustomers"
        | "numberOfZones"
        | "DeliveryMethodContainerRules"
      >
    | undefined;
}) => {
  const palletOverrideEnabled = useRemoteFeatureFlags().isActive(
    "courierHaulierEnforcement",
  );

  return (
    <DeliveryOptionsCardCompact
      supplierId={supplierId}
      fulfillmentType={haulierFulfillmentType}
      description="Typically delivered in 1-3 business days from dispatch"
      title={
        <p>
          Delivered by{" "}
          <strong>{palletOverrideEnabled ? "Pallet" : "Haulier"}</strong>
        </p>
      }
    />
  );
};
